// Same rule as the backend's `needToBeAdmin`, read off `/user/me` rather than localStorage,
// which anyone can edit.
export const isAdminUser = (me: any) => !!me && (me.isAdmin === true || me.role === "admin");

// "Afficher le menu Back-office" (Paramètres → Admin). Shown unless explicitly turned off,
// so admins keep their menu until they choose to hide it.
const SHOW_BO_MENU_KEY = "showAdminRed";

export const getShowBoMenu = () => localStorage.getItem(SHOW_BO_MENU_KEY) !== "false";

export const setShowBoMenu = (value: boolean) => {
    localStorage.setItem(SHOW_BO_MENU_KEY, String(value));
    // Same-tab listeners (the sidebar) don't get native storage events.
    window.dispatchEvent(new Event("storage"));
};
